<header>
  <div class="black-bar">
    @if (enableMembers) {
      <div class="login-bar">
        <app-member-bar></app-member-bar>
      </div>
    }
  </div>
  @if (showShipping && isMobile) {
    <div class="menu">
      <button class="unstyled-button" (click)="openMenu()">
        <mat-icon [svgIcon]="menuIcon">Menu</mat-icon>
        <span aria-hidden="true">Menu</span>
      </button>
    </div>
  }
  <a routerLink="/" class="logo-container">
    <img [src]="storeLogo.src | cms: 50" [alt]="storeLogo.alt" aria-hidden="true" />
    <span class="screen-reader-only">{{ storeLogo.alt }}</span>
  </a>
  <div class="controls">
    <a [routerLink]="customerServiceUrl" class="store">
      <mat-icon svgIcon="support"></mat-icon>
      <span class="notranslate label">Kundeservice</span>
    </a>
    @if (!isEventStore) {
      @if (findShopUrl) {
        @if (!findShopUrlSameSite) {
          <a [href]="findShopUrl" target="_blank" class="store">
            <mat-icon svgIcon="location"></mat-icon>
            <span class="notranslate label">{{ store }}</span>
          </a>
        }
        @if (findShopUrlSameSite) {
          <a [routerLink]="findShopUrl" class="store">
            <mat-icon svgIcon="location"></mat-icon>
            <span class="notranslate label">{{ store }}</span>
          </a>
        }
      }
      @if (!findShopUrl) {
        <div class="store">
          <mat-icon svgIcon="location"></mat-icon>
          <span class="notranslate label">{{ store }}</span>
        </div>
      }
    }
    <div class="basket">
      @let price = price$ | async;
      <app-icon-button id="basket" [icon]="basketIcon" [routerLink]="basketUrl" [matBadge]="count$ | async" [border]="false">
        @if (price <= 0) {
          Kurv
        }
        @if (price > 0) {
          {{ price | number: '.2-2' : locale }} {{ currency | displayCurrency }}
        }
      </app-icon-button>
      <span id="price" class="label" aria-hidden="true">
        @if (price <= 0) {
          Kurv
        }
        @if (price > 0) {
          {{ price | number: '.2-2' : locale }} {{ currency | displayCurrency }}
        }
      </span>
    </div>
  </div>
</header>
